// RESIDENCE commission structure. One place for every split/cap number.
// Keyed by login email for the team leader because uids differ between the TEST and live projects.
export const COMMISSION = {
  // Team leader (Kelly): no team split. eXp 80/20, eXp's 20% stops once $16,000 is paid in the cap year.
  teamLeader: { email: 'kelly.olin@exprealty.com', brokerPercent: 20, annualCap: 16000 },
  // Every other agent: team leader share depends on the deal's lead source, then eXp takes 20% of
  // the agent's portion until that agent has paid $8,000 to eXp in the cap year.
  agent: { leaderSharePercent: { agent: 25, team: 50 }, brokerPercent: 20, annualCap: 8000 },
  // Cap year starts Jan 1 (calendar year).
  capResetMonth: 1,
  capResetDay: 1,
  // Deals with no lead source are treated as team leads until someone sets it.
  defaultLeadSource: 'team',
  // Kelly's team override income (her share of agents' deals) counts toward her eXp cap (confirmed by Kelly).
  overrideCountsTowardLeaderCap: true,
};
export const isTeamLeaderEmail = (email) => String(email || '').toLowerCase() === COMMISSION.teamLeader.email;
